import { Action } from 'redux';

import { TComplainComplaintsFetched } from '../../actions/complain';

export type TComplainRequest = 'complain/request';
export type TComplainFailRequest = 'complain/failRequest';

export interface IComplainRequest extends Action<TComplainRequest> {
  offerId: number;
  type: TComplainRequest;
}

export interface IComplainFailRequest extends Action<TComplainFailRequest> {
  isError: boolean;
  type: TComplainFailRequest;
}

export const COMPLAIN_FAIL_REQUEST: TComplainFailRequest = 'complain/failRequest';
export const COMPLAIN_COMPLAINTS_FETCHED: TComplainComplaintsFetched = 'complain/complaintsFetched';
